import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { ApplicationsService } from '@core/services/applications.service';
import { App } from '@shared/interfaces/app';
import { Store } from '@ngrx/store';
import { appLoaded } from '@store/actions/app.actions';
import { catchError, NEVER, Observable, tap } from 'rxjs';

export const AppResolverFn: ResolveFn<App> = (
	route: ActivatedRouteSnapshot
): Observable<App> => {
	const router = inject(Router);
	const store = inject(Store);
	const applicationsSvc = inject(ApplicationsService);

	const appIdParam = route.paramMap.get('appId');
	const appId = appIdParam !== null ? parseInt(appIdParam, 10) : null;

	return applicationsSvc.find(appId).pipe(
		tap((app) => store.dispatch(appLoaded({ app }))),
		catchError((error) => {
			router.navigateByUrl('/error', {
				state: { data: 'APP_NOT_FOUND', error: error.message }
			});
			return NEVER;
		})
	);
};
